




// ****************** BEGIN COLUMNS ****************************

import {changeContract} from "./contractSlice";
import {Avatar, Tooltip} from "@mui/material";
import AbstractStatusMenu from "./AbstractStatusMenu";
import Box from "@mui/material/Box";
import * as React from "react";
// import {useDispatch} from "react-redux";
import ContractGridMenu from "./ContractGridMenu";


export const ContractGridColumns = ({ handleDrilldown, dispatchData, hideActions, selectorContractGridAPI, selectorContractId2,
   setSubmitting, navigate, selectorContractAPI,currentUserId,
                                        currentUserName,
                                        currentUserDepartment,
    handleEdit,selectorContractId,
                                        onCsList,
                                        onCsfList,
                                        onCdpList,
                                        onCdpvList,
                                        onCdpvfList,
                                        onVocabularyList,
                                        onMarketList,
                                        fetchContracts, selectorRights}) => [
// const columns = (fetchContracts, selectorRights) => [




    { field: "more",
        headerName: '',
        width: 20,
        padding: 0,
        margin: 0,
        sortable: false,
        menu: false,
        filterable: false,
        hide: hideActions,
        renderCell: (contracts) => {
            return (
                <div
                    onMouseOver={()=> dispatchData(changeContract({
                        cloneId: contracts.row.id, id: contracts.row.id,
                        mcode: contracts.row.mcode, name: contracts.row.name, description: contracts.row.description,
                        status: contracts.row.status, ordinalNumber: contracts.row.ordinalNumber, recordLevel: contracts.row.recordLevel,
                        hierarchy: contracts.row.hierarchy, lastModifiedOn: contracts.row.lastModifiedOn, lastModifiedBy: contracts.row.lastModifiedBy,
                        createdOn: contracts.row.createdOn, createdBy: contracts.row.createdBy
                    }))
                    }
                >
                    <Tooltip
                        enterDelay={1000}
                        enterNextDelay={1000}
                        title={`Click to see actions for record ${contracts.row.id}`}
                    >
                        <ContractGridMenu
                            dispatchData={dispatchData}
                            selectorContractId2={selectorContractId2}
                            selectorContractAPI={selectorContractAPI}
                            setSubmitting={setSubmitting}
                            currentUserId={currentUserId}
                        currentUserName={currentUserName}
                        currentUserDepartment={currentUserDepartment}
                            handleEdit={handleEdit}
                            selectorContractGridAPI={selectorContractGridAPI}
                            selectorContractId={selectorContractId}
                            handleDrilldown={handleDrilldown}
                        />
                    </Tooltip></div>
            );
        }
    },
    {
        field: 'abstractStatus',
        headerName: 'Status',
        width: 60,
        sortable: false,
        renderCell: (contracts) => <AbstractStatusMenu rowContractData={contracts.row} />,
        hide: selectorContractGridAPI !== "PartsAbstracts" && selectorContractGridAPI !== "RoyalAbstracts"
    },
    // const rowContractData = contracts.row;
    // return (<div onMouseOver={() => handleMousedRow(contracts.row)}>
    //         {/*// <MoreHorizIcon fontSize={'small'} onClick= {() => handleControls()}/>*/}
    //         <ContractStatusMenu rowContractData={rowContractData}/>
    // {(selectorContractAPI === "PartsAbstract") &&
    // <AbstactStatusMenu/>},

    // {
    //     field: 'ordinalNumber',
    //     headerName: 'num',
    //     description: '',
    //     width: 100,
    // },
    // {
    //     field: 'id',
    //     headerName: 'id',
    //     description: '',
    //     width: 100,
    // },
    {
        field: 'name',
        headerName: 'Name',
        description: '',
        sortable: true,
        editable: true,
        width: 1000,
        renderCell: (contracts) => {
            return (
                <Tooltip enterDelay={1000} enterNextDelay={1000}  title={<span style={{whiteSpace: 'pre-line'}}>
                    {"id: " + contracts.row.id +
                        "\ndescription: " + contracts.row.description +
                        "\ncode: " + contracts.row.mcode
                    }</span>}>
                    <p onClick= {() => handleDrilldown(contracts.row.id, contracts.row.mcode, contracts.row.name, contracts.row.description, contracts.row)}
                       style={{cursor:'pointer'}} >
                        {/*<p onClick={() => dispatchContractId(changeContract({id: contracts.row.id, mcode: contracts.row.mcode, name: contracts.row.name, description: contracts.row.description }))}>*/}
                        {contracts.row.name} </p></Tooltip>
            );
        }

    },
    {
        field: 'description',
        headerName: 'Description',
        description: '',
        sortable: false,
        editable: true,
        width: 1400,
        hide: true,
        renderCell: (contracts) => {
            return (
                <Tooltip enterDelay={1000}  enterNextDelay={1000} title={<span style={{whiteSpace: 'pre-line'}}>
                    {"id: " + contracts.row.id +
                        "\ncode: " + contracts.row.mcode
                    }</span>}>
                    <p onClick= {() => handleDrilldown(contracts.row.id, contracts.row.mcode, contracts.row.name, contracts.row.description, contracts.row)}
                       style={{cursor:'pointer'}} >
                        {contracts.row.description} </p></Tooltip>
            );
        }
    },
    {
        field: 'mcode',
        headerName: 'Code',
        description: '',
        sortable: true,
        editable: true,
        hide: true,
        width: 200,
    },
    {
        field: 'status',
        headerName: 'Status',
        description: '',
        width: 100,
        hide: true
    },
    {    field: 'hierarchy',
        headerName: 'hierarchy',
        description: '',
        sortable: true,
        width: 60,
        hide: true,
    },
    // {    field: 'ordinalNumber',
    //     headerName: 'ordinalNumber',
    //     description: '',
    //     sortable: true,
    //     width: 60,
    //     hide: true,
    // },
    {    field: 'recordLevel',
        headerName: 'recordLevel',
        description: '',
        sortable: true,
        width: 60,
        hide: true,
    },
    {
        field: 'createdOn',
        headerName: 'createdOn',
        description: '',
        width: 100,
        hide: true
    },
    {
        field: 'createdBy',
        headerName: 'createdBy',
        description: '',
        width: 100,
        hide: true
    },
    {
        field: 'lastModifiedOn',
        headerName: 'lastModifiedOn',
        description: '',
        width: 100,
        hide: true
    },
    {
        field: 'lastModifiedBy',
        headerName: 'lastModifiedBy',
        description: '',
        width: 100,
        hide: true
    },

    {
        field: 'csCount',
        headerName: 'Sections',
        headerAlign: 'center',
        width: 100,
        renderCell: (contracts) => {
            const count = contracts.row.csCount;

            if (count === 0 || count === null || count === undefined) return "";

            // Calculate width based on digit count
            const digitCount = count.toString().length;
            const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

            return (
                <Box sx={{
                    width: "100%",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Tooltip title={"Count of contract sections."}
                             onClick= {() => onCsList(contracts.row.id, contracts.row.name)}>
                        <Avatar variant="rounded" sx={{
                            height: 20,
                            width,
                            fontSize: 16,
                            bgcolor: "rgb(30,144,255)"
                        }}
                                style={{cursor:'pointer'}}
                        >
                            {count}
                        </Avatar>
                    </Tooltip>
                </Box>
            );
        }
    },

    {
        field:  'csfCount',
        headerName: 'Section Filters',
        headerAlign: 'center',
        width: 120,
        renderCell: (contracts) => {
            const count = contracts.row.csfCount;

            if (count === 0 || count === null || count === undefined) return "";

            // Calculate width based on digit count
            const digitCount = count.toString().length;
            const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

            return (
                <Box sx={{
                    width: "100%",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Tooltip title={"Count of contract section filters."}
                             onClick= {() => onCsfList(contracts.row.id, contracts.row.name)}>
                        <Avatar variant="rounded" sx={{
                            height: 20,
                            width,
                            fontSize: 16,
                            bgcolor: "rgb(30,144,255)"
                        }}
                                style={{cursor:'pointer'}}
                        >
                            {count}
                        </Avatar>
                    </Tooltip>
                </Box>
            );
        }
    },

    {
        field:  'cdpCount',
        headerName: 'Data Points',
        headerAlign: 'center',
        width: 100,
        renderCell: (contracts) => {
            const count = contracts.row.cdpCount;

            if (count === 0 || count === null || count === undefined) return "";

            // Calculate width based on digit count
            const digitCount = count.toString().length;
            const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

            return (
                <Box sx={{
                    width: "100%",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Tooltip title={"Data Point is used in contracts.  Click to see where."}
                             onClick= {() => onCdpList(contracts.row.id, contracts.row.name)}>
                        <Avatar variant="rounded" sx={{
                            height: 20,
                            width,
                            fontSize: 16,
                            bgcolor: "rgb(30,144,255)"
                        }}
                                style={{cursor:'pointer'}}
                        >
                            {count}
                        </Avatar>
                    </Tooltip>
                </Box>
            );
        }
    },

    {
        field:  'cdpvCount',
        headerName: 'Values',
        headerAlign: 'center',
        width: 100,
        renderCell: (contracts) => {
            const count = contracts.row.cdpvCount;

            if (count === 0 || count === null || count === undefined) return "";

            // Calculate width based on digit count
            const digitCount = count.toString().length;
            const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

            return (
                <Box sx={{
                    width: "100%",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Tooltip title={"Count of contract data point values."}
                             onClick= {() => onCdpvList(contracts.row.id, contracts.row.name)}>
                        <Avatar variant="rounded" sx={{
                            height: 20,
                            width,
                            fontSize: 16,
                            bgcolor: "rgb(30,144,255)"
                        }}
                                style={{cursor:'pointer'}}
                        >
                            {count}
                        </Avatar>
                    </Tooltip>
                </Box>
            );
        }
    },

    {
        field:  'cdpvfCount',
        headerName: 'Value Filters',
        headerAlign: 'center',
        width: 100,
        renderCell: (contracts) => {
            const count = contracts.row.cdpvfCount;

            if (count === 0 || count === null || count === undefined) return "";

            // Calculate width based on digit count
            const digitCount = count.toString().length;
            const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

            return (
                <Box sx={{
                    width: "100%",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Tooltip title={"Count of contract data point value filters."}
                             onClick= {() => onCdpvfList(contracts.row.id, contracts.row.name)}>
                        <Avatar variant="rounded" sx={{
                            height: 20,
                            width,
                            fontSize: 16,
                            bgcolor: "rgb(30,144,255)"
                        }}
                                style={{cursor:'pointer'}}
                        >
                            {count}
                        </Avatar>
                    </Tooltip>
                </Box>
            );
        }
    },

    {
        field:  'vocabCount',
        headerName: 'Vocabulary',
        headerAlign: 'center',
        width: 100,
        renderCell: (contracts) => {
            const count = contracts.row.vocabCount;

            if (count === 0 || count === null || count === undefined) return "";

            // Calculate width based on digit count
            const digitCount = count.toString().length;
            const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

            return (
                <Box sx={{
                    width: "100%",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Tooltip title={"Count of distinct data points."}
                             onClick= {() => onVocabularyList(contracts.row.id, contracts.row.name)}>
                        <Avatar variant="rounded" sx={{
                            height: 20,
                            width,
                            fontSize: 16,
                            bgcolor: "rgb(30,144,255)"
                        }}
                                style={{cursor:'pointer'}}
                        >
                            {count}
                        </Avatar>
                    </Tooltip>
                </Box>
            );
        }
    },
    {
        field: 'marketCount',
        headerName: 'Markets',
        headerAlign: 'center',
        width: 100,
        renderCell: (contracts) => {
            const count = contracts.row.marketCount;

            if (count === 0 || count === null || count === undefined) return "";

            // Calculate width based on digit count
            const digitCount = count.toString().length;
            const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

            return (
                <Box sx={{
                    width: "100%",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Tooltip title={"Count of residuals markets."}
                             onClick= {() => onMarketList(contracts.row.id, contracts.row.name)}>
                        <Avatar variant="rounded" sx={{
                            height: 20,
                            width,
                            fontSize: 16,
                            bgcolor: "rgb(30,144,255)"
                        }}
                                style={{cursor:'pointer'}}
                        >
                            {count}
                        </Avatar>
                    </Tooltip>
                </Box>
            );
        }
    },
];

// ****************** END COLUMNS ****************************
